import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import moment from "moment";
import Datetime from "react-datetime";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ReactComponent as IconDate } from "../../../../layout/input_placeholder_icons/icon_date.svg";

export default function CourseByDate({ searchObject, t, setSearchObject }) {
  const { i18n } = useTranslation();
  const [startDateIsOpen, setStartDateIsOpen] = useState(false);
  const [endingDateIsOpen, setEndingDateIsOpen] = useState(false);

  const isValidEndDate = (currentDate) => {
    if (searchObject.courseStartDate) {
      return searchObject.courseStartDate < currentDate;
    } else {
      return true;
    }
  };

  const isValidStartDate = (currentDate) => {
    if (searchObject.courseStartDate) {
      return searchObject.courseStartDate > currentDate;
    } else {
      return true;
    }
  };

  function onChangeDateStart(date) {
    setStartDateIsOpen(false);
    setSearchObject({
      ...searchObject,
      courseStartDate: new Date(date._d.getFullYear(), 0, 1)
    });
  }

  function onChangeDateEnd(date) {
    setEndingDateIsOpen(false);
    setSearchObject({
      ...searchObject,
      courseEndDate: new Date(date._d.getFullYear(), 11, 31)
    });
  }

  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Course Dates")}</legend>
        <div className="row">
          <div className="col">
            <div className="input-group">
              <Datetime
                className="col-9"
                timeFormat={false}
                dateFormat="YYYY"
                value={moment(`${searchObject.courseStartDate}/01/01`) || ""}
                open={startDateIsOpen}
                onChange={onChangeDateStart}
                utc={true}
                inputProps={{ readOnly: true, placeholder: t("Start date") }}
                isValidDate={isValidStartDate}
                locale={
                  i18n.language === "PT"
                    ? "PT"
                    : i18n.language === "FR"
                    ? "FR"
                    : "EN"
                }
                renderInput={() => {
                  return (
                    <input
                      value={
                        searchObject.courseStartDate
                          ? moment(searchObject.courseStartDate).format("YYYY")
                          : ""
                      }
                      className="form-control fontsize-legend"
                      disabled
                    />
                  );
                }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setStartDateIsOpen(!startDateIsOpen)}
              >
                <IconDate />
              </button>
            </div>
          </div>
          <div className="col">
            <div className="input-group">
              <Datetime
                className="col-9"
                timeFormat={false}
                dateFormat="YYYY"
                open={endingDateIsOpen}
                onChange={onChangeDateEnd}
                value={moment(`${searchObject.courseEndDate}-12-31`) || ""}
                utc={true}
                isValidDate={isValidEndDate}
                inputProps={{ readOnly: true, placeholder: t("End Date") }}
                locale={
                  i18n.language === "PT"
                    ? "PT"
                    : i18n.language === "FR"
                    ? "FR"
                    : "EN"
                }
                renderInput={(props) => {
                  return (
                    <input
                      value={
                        searchObject.courseEndDate
                          ? moment(searchObject.courseEndDate).format("YYYY")
                          : ""
                      }
                      className="form-control fontsize-legend"
                      disabled
                    />
                  );
                }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setEndingDateIsOpen(!endingDateIsOpen)}
              >
                <IconDate />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
